import { useDropzone } from 'react-dropzone';

import { IMAGE_UPLOAD_CONSTANTS } from '@/views/build/constant';
import { useConfirmImageReplace } from '@/views/build/hook/useConfirmImageReplace';

export const useDroppableImageUpload = ({
  onUploadStart,
  imageUrl,
}: {
  onUploadStart: (file: File) => void;
  imageUrl?: string;
}) => {
  const { confirm } = useConfirmImageReplace();

  const { getRootProps, getInputProps, isDragActive, inputRef } = useDropzone({
    onDrop: (files: File[]) => {
      void (async () => {
        if (!imageUrl) {
          onUploadStart(files[0]);
          return;
        }
        const shouldReplaceImage = await confirm();
        if (!shouldReplaceImage) return;
        onUploadStart(files[0]);
      })();
    },
    noClick: true,
    noKeyboard: true,
  });

  return {
    rootProps: { ...getRootProps() },
    inputProps: {
      ...getInputProps(),
      accept: IMAGE_UPLOAD_CONSTANTS.ALLOWED_IMAGE_EXTENSIONS.map(
        extension => `image/${extension}`,
      ).join(','),
    },
    isDragActive,
    inputRef,
  };
};
